import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLinkDetail, PaymentLinkStatus } from '@types'
import { paymentLinkDetailBaseMock } from './payment-link-detail-base'

export const paymentLinkDetailSentMock = new MockFactory<PaymentLinkDetail>({
  ...paymentLinkDetailBaseMock.build(),
  status: PaymentLinkStatus.LinkSent,
})
